export const SmartDocType_Regular = 'regular';
export const SmartDocType_PhysicianNote = 'physician_note';
export const SmartDocType_Summary = 'summary';
export const SmartDocType_Order = 'order';
export const SmartDocsType_Enum = {
    REGULAR: SmartDocType_Regular,
    PHYSICIAN_NOTE: SmartDocType_PhysicianNote,
    SUMMARY: SmartDocType_Summary,
    ORDER: SmartDocType_Order
};
export const DefaultTitle_ProvidersNote = 'Provider\'s Note';
//# sourceMappingURL=consts.js.map